import {ChevronRight, Copy, Check} from 'lucide-react'
import {useState} from 'react'

export default function About() {
  const [copied, setCopied] = useState(false)
  const contractAddress = '0x7a8adcf432ebcc2311b955d176ee4bfed13bb9a7'

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contractAddress)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <>
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4 overflow-hidden z-10">
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="flex justify-center mb-6 relative">
            <div className="relative w-full max-w-2xl">
              <div className="absolute top-[15%] right-[20%] transform translate-x-1/4">
                <p className="text-xl sm:text-2xl font-semibold text-white/90">
                  Welcome to
                </p>
              </div>
              <img src="https://static.lumi.new/2b/2bff9521edc8f88a8f9beed00b2498e4.webp" alt="Mandox" className="w-full h-auto" />
            </div>
          </div>
          <p className="text-lg sm:text-xl text-white/60 mb-10 max-w-2xl leading-relaxed text-center mx-auto px-4">
            The decentralized token powering a vibrant ecosystem where creativity, community, and blockchain innovation come together.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
            <a href="https://static.lumi.new/54/5411c838effd7988eb6ee38390ae6d76.pdf" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 bg-white text-black rounded-xl font-semibold text-sm hover:bg-white/90 transition-colors">
              View Whitepaper
            </a>
            <a href="https://coinsult.net/projects/mandox/" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 bg-white text-black rounded-xl font-semibold text-sm hover:bg-white/90 transition-colors">
              Audit
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="relative py-20 px-4 z-10">
        <div className="max-w-7xl mx-auto">
          <div className="mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-white text-center">
              What is $MANDOX?
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/60 max-w-3xl leading-relaxed text-center mx-auto px-4">
              $MANDOX is an ERC-20 token on Ethereum, designed from the ground up to bridge cryptocurrencies and NFTs. Today, it's fully community-driven and decentralized, empowering holders, creators, collectors, and gamers to shape the project's direction and growth.
            </p>
          </div>

          <div className="max-w-5xl mx-auto space-y-16">
            <div className="text-center space-y-4">
              <h3 className="text-3xl sm:text-4xl font-bold text-white mb-6">Our Vision</h3>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed max-w-3xl mx-auto">
                We exist to build a safe, open, and exciting space in the cryptoverse. $MANDOX connects enthusiasts with real utility: seamless NFT creation and trading, cross-chain tools, and meaningful real-world impact. Transparency, accessibility, and community ownership define everything we do.
              </p>
            </div>
            
            <div className="text-center space-y-6">
              <h3 className="text-3xl sm:text-4xl font-bold text-white mb-6">The Mandox Ecosystem</h3>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed max-w-3xl mx-auto mb-8">
                $MANDOX fuels a growing universe of interconnected tools and platforms:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
                <div className="bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-3">Mandox Token</h4>
                  <p className="text-base sm:text-lg text-white/70 leading-relaxed">Decentralized token on the Ethereum Blockchain</p>
                </div>
                <div className="bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-3">Mandox Create</h4>
                  <p className="text-base sm:text-lg text-white/70 leading-relaxed">The world's first universal NFT social media marketplace, powered by Wire Network. Mint, showcase, buy, sell, and trade NFTs across chains with artist-first features, low costs, and true interoperability. Live release coming soon!</p>
                </div>
                <div className="bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-3">Mandox NFTs</h4>
                  <p className="text-base sm:text-lg text-white/70 leading-relaxed">Exclusive, limited-supply digital collectibles with perks through the Mandox GEM reward system.</p>
                </div>
                <div className="bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-3">The Incinerator</h4>
                  <p className="text-base sm:text-lg text-white/70 leading-relaxed">A deflationary burn engine for $MANDOX, automatically burning a portion of every transaction on-chain to drive long-term scarcity and transparency.</p>
                </div>
                <div className="bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-3">Mandox Exchange</h4>
                  <p className="text-base sm:text-lg text-white/70 leading-relaxed">A dedicated decentralized exchange hub for the Mandox ecosystem, enabling seamless token swaps, liquidity access, and cross-chain trading powered by the $MANDOX community.</p>
                </div>
                <div className="bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-3">Mandox Smart Contract Audits</h4>
                  <p className="text-base sm:text-lg text-white/70 leading-relaxed">Professional EVM smart contract security auditing for token projects. Audit your token, earn trust on-chain, and protect your community with transparent, verifiable security reviews. Coming soon.</p>
                </div>
              </div>
            </div>
            
            <div className="text-center space-y-4">
              <h3 className="text-3xl sm:text-4xl font-bold text-white mb-6">Join the Mandox Community</h3>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed max-w-3xl mx-auto mb-4">
                Whether you're here to create NFTs, dive into gaming, trade across chains, or support a project that gives back — you're part of the Militia now.
              </p>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed max-w-3xl mx-auto">
                Together, we're not just holding a token — we're building the future of decentralized creativity and utility.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="relative py-20 px-4 z-10">
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-xl overflow-hidden shadow-[0_0_40px_rgba(255,255,255,0.5)] hover:shadow-[0_0_60px_rgba(255,255,255,0.7)] transition-all duration-300">
            <div className="relative pb-[56.25%] h-0">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/xjCWH1Inf4Y"
                title="Mandox Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
